/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Phone/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import Apps from './Apps/index'
import PreferredIcon from './PreferredIcon/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Phone({
  children,
  viewPath = "/DesignSystem/PatientOverview/Content/Contact/Content/Phones/Content/Phone"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let phonePhoneNumberValueData = fromData.useDataFormat({ viewPath,
context: 'phone',
path: 'phone.number',
format: fromFormat.phoneNumberUS,
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<div
  data-testid="Phone.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-5yCzy': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-2-5yCzy': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--g-3-5yCzy': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral900}
 data="phone.phone.number"
 format="/Data/format.js phoneNumberUS"
 text={phonePhoneNumberValueData}
/>
<PreferredIcon
  viewPath={`${viewPath}/PreferredIcon`}
/>
<Apps
  viewPath={`${viewPath}/Apps`}
/>
</div>
{children}
</React.Fragment>)
}